module.exports = __webpack_public_path__ + "img/901277890.56907fdd.png";